import { Box } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import EdgeDetailContent from "../components/Layout/EdgeDetailContent";
import Sidebar from "../components/Layout/Sidebar";
import { useEdgeDetail } from "../hooks/useEdgeDetail";

/**
 * Standalone page view for relationship/edge details
 * Displays relationship information in a centered, full-page layout
 * Uses URL parameter :relationshipId to determine which relationship to display
 */
const RelationDetailPage: React.FC = () => {
  const { relationshipId } = useParams<{ relationshipId: string }>();
  const navigate = useNavigate();

  // Fetch edge data using custom hook
  const { edgeDetailResponse, loading, error } = useEdgeDetail(
    relationshipId || null
  );

  // Handle entity navigation - navigate to entity detail page
  const handleEntityClick = (entityId: string) => {
    navigate(`/entity/${entityId}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        backgroundColor: "background.paper",
      }}
    >
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content - Full Width with Centered Inner Content */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <EdgeDetailContent
          edgeDetailResponse={edgeDetailResponse}
          loading={loading}
          error={error}
          onEntityClick={handleEntityClick}
          mode="standalone"
        />
      </Box>
    </Box>
  );
};

export default RelationDetailPage;
